module.exports = __webpack_public_path__ + "img/logotipo.6dba57c5.png";